
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.25 6a2.25 2.25 0 104.5 0 2.25 2.25 0 10-4.5 0zM4.5 9.75A3.75 3.75 0 00.75 13.5v2.25h1.5l.75 6h3M17.25 6a2.25 2.25 0 104.5 0 2.25 2.25 0 10-4.5 0zm2.25 3.75a3.75 3.75 0 013.75 3.75v2.25h-1.5l-.75 6h-3m-9-18a3 3 0 106 0 3 3 0 10-6 0zm8.25 9.75a5.25 5.25 0 00-10.5 0v2.25H9l.75 7.5h4.5l.75-7.5h2.25z","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    